import React from "react";
import { useDispatch } from "react-redux";
// import ExportToCsvButton from '../../../../../components/presentationals/ExportToCsvButton';
import { ExportToCsv } from "export-to-csv";
import {
  triggerFetchRechargeSalesCsvAPI,
  fetchShowAlertRecharge,
  hideAlertRecharge,
} from "../../../../redux/actions/rechargeSalesAction";
import { csvMappingRechargeSales } from "../../../../utils/common/csvMappings/rechargeSales";
import CustomCardView from "../../../../views/rechargeSales/sales/component/customCardView";
import { lmtdCheck } from "../../../../utils/common";
const CustomCard = (props) => {
  const dispatch = useDispatch();
  const { data } = props;
  const filterData = props.filterValue;
  // const [csvData, setCsvData] = useState([]);
  // const [downloadCsv, setDownloadCsv] = useState(false);
  // const { rechargeSalesCsvObj } = useSelector(state => state.rechargeSalesReducer);
  function fetchCsvData(tab) {
    // setDownloadCsv(true);
    const obj = {
      headers: {
        "Content-Type": "application/json",
        url: props.csvUrl,
      },
      params: props.body,
      extraData: props.csvUrl,
      tab,
    };
    let options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      filename: "RechargeSales_sales",
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    let csvExporter = new ExportToCsv(options);
    return dispatch(
      triggerFetchRechargeSalesCsvAPI(obj, (response, params) => {
        if (response?.content?.length) {
          // console.log(data);
          let csvData;
          csvData = csvMappingRechargeSales({
            partnerRole:
              props.filterValue.selectedJC === ""
                ? props.filterValue.selectedPartnerRoleName
                : props.filterValue.selectedJC === "ALL"
                ? props.filterValue.selectedPartnerRoleName
                : "JP",
            data: response.content,
            option: params.dist,
            tileName: props.tileName.toLowerCase().split(" ")[0],
            section: "sales",
          });
          // if (params.dist === "billed") {
          //   csvData = billedFilter(response.content, "recharge");
          // } else {
          //   csvData = onBoardedFilter(response.content, "recharge");
          // }
          csvExporter.generateCsv(csvData);
        } else {
          dispatch(fetchShowAlertRecharge());
          setTimeout(() => {
            dispatch(hideAlertRecharge());
          }, 5000);
        }
      })
    );
  }

  return (
    <CustomCardView
      data={props.data}
      fetchCsvData={fetchCsvData}
      id={props.id}
      filterData={filterData}
      body={props.body}
      headerUnit={props.headerUnit}
      lmtdCheck={lmtdCheck}
      isCsvActive={props.isCsvActive}
      tileName={props.tileName}
      rechargeSalesCsvLoading={props.rechargeSalesCsvLoading}
      headerSelectedDateFrom={props.headerSelectedDateFrom}
      headerSelectedDateTo={props.headerSelectedDateTo}
      dashboardName={props.dashboardName}
      viewName={props.viewName}
    />
  );
};
export default CustomCard;
